import * as React from 'react';
import withEximType from './withEximType';
import { connect } from 'react-redux';
import UnauthorizedAccess from '../common/UnauthorizedAccess';
import { map } from './eximTypeMapping';
import Navbar from '../navbar/Navbar';
import { equal } from 'src/Library/Helper';

const withAuthAccessExim = (groupIds, hideNavbar = false) => {
  return (Component) => {
    class WithAuthAccessExim extends React.PureComponent<any, any> {
      isGroupAuthorized = ():boolean =>  {
        const { config, eximType } = this.props;
        if (eximType === '') {
          return config && groupIds && groupIds.length &&
        groupIds.some((groupId: string) => (config[groupId]));
        }
        return config && map[groupIds[0]][eximType] && map[groupIds[0]][eximType].length &&
      map[groupIds[0]][eximType].some((groupId : string) => config[groupId]);
      }

      // To show organisation profiles of other org types to shipping lines and Trucking Agents
      isMyOrganisationFromMasters = () : boolean => {
        const { match, type } = this.props;
        return match.params.orgType && match.params.orgId;
      }

      render() {
        // During the forced change-password flow the master-data fetch fails
        // (BE returns 403 EUSS008), so partsToShow is empty and this HOC would
        // mask the Account screen with UnauthorizedAccess. RouterOutlet already
        // pins the user to `/account?forceChangePassword=1` while expired, so
        // bypassing the part-permission check here is bounded to that route.
        if (this.props.passwordExpired) {
          return <Component {...this.props}></Component>;
        }
        if (!(this.isGroupAuthorized() || this.isMyOrganisationFromMasters())) {
          return <div>
            {!hideNavbar && <Navbar pageTitle="Not Authorized" />}
            <UnauthorizedAccess />
          </div>;
        }
        return <Component {...this.props}></Component>;
      }
    }
    const mapStateToProps = ({ authUser, masterData, logoutReducer }, ownProps) => ({
      config: authUser.partsToShow,
      type: masterData.userData.type,
      organisationModesOfService: masterData.organisationModesOfService,
      passwordExpired: logoutReducer?.passwordExpired === true,
    });
    return connect(mapStateToProps, null)(withEximType(WithAuthAccessExim));
  };
};

export default withAuthAccessExim;
